
webpack.register(
    'components/player-selection-tabs/player-selection-tabs',
    function() {
        return import('components/player-selection-tabs/player-selection-tabs');
    },
    true
);